define('i18n',['json!i18ntr/messages.json', 'core/format'], function (i18nTr, format) {
  'use strict';

  var translations = i18nTr.translations;
  var rubyTags = /\{(ruby|rt|rb|rp)\}|\{\/(ruby|rt|rb|rp)\}/g;
  function convertRubyTags(text) {
    return text.replace(rubyTags, (match, open, close) => {
      return open ? "<".concat(open, ">") : "</".concat(close, ">");
    });
  }
  function plainTextFromRuby(text) {
    if (typeof text !== 'string' || text === '') {
      return text === null || text === undefined ? '' : String(text);
    }
    var plain = convertRubyTags(text);
    plain = plain.replace(/<rt[^>]*>[\s\S]*?<\/rt>/gi, '');
    plain = plain.replace(/\{rt\}[\s\S]*?\{\/rt\}/g, '');
    plain = plain.replace(/<rp[^>]*>[\s\S]*?<\/rp>/gi, '');
    plain = plain.replace(/\{rp\}[\s\S]*?\{\/rp\}/g, '');
    plain = plain.replace(/<[^>]+>/g, '');
    plain = plain.replace(/\s+/g, ' ').trim();
    return plain;
  }
  function __(message) {
    var localized = translations[message] || message;
    if (arguments.length > 1) {
      localized = format.apply(null, [localized].concat([].slice.call(arguments, 1)));
    }
    return convertRubyTags(localized);
  }
  __.plainTextFromRuby = plainTextFromRuby;
  return __;
});
